import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Hồ sơ nhân sự. Mã nghiệp vụ và dữ liệu không dịch.
addMessages('vi', {
  'sp.status': 'Trạng thái',
  'sp.working': 'Đang làm',
  'sp.backList': 'Về danh sách nhân sự',
  'sp.newStaff': 'Nhân sự mới',
  'sp.profileOf': 'Hồ sơ của',
  'sp.todoSync': 'Đồng bộ chức danh sang M365',
  'sp.todoDone': 'Xong: Đồng bộ chức danh sang M365',
  'sp.thisWeek': 'Tuần này',
  'sp.sync': 'Đồng bộ',
  'sp.syncShort': 'Đồng bộ chức danh',
  'sp.noTodo': 'Không còn việc nào.',
  'sp.mkDecision': 'Lập quyết định nhân sự',
  'sp.mkDecisionSub': 'Tăng lương, thăng cấp, điều chuyển, kiêm nhiệm…',
  'sp.staffList': 'Danh sách nhân sự',
  'sp.toList': 'Về danh sách',
});
addMessages('en', {
  'sp.status': 'Status',
  'sp.working': 'Active',
  'sp.backList': 'Back to staff list',
  'sp.newStaff': 'New staff',
  'sp.profileOf': 'Profile of',
  'sp.todoSync': 'Sync job title to M365',
  'sp.todoDone': 'Done: Sync job title to M365',
  'sp.thisWeek': 'This week',
  'sp.sync': 'Sync',
  'sp.syncShort': 'Sync job title',
  'sp.noTodo': 'Nothing left to do.',
  'sp.mkDecision': 'Create HR decision',
  'sp.mkDecisionSub': 'Raise, promotion, transfer, concurrent role…',
  'sp.staffList': 'Staff list',
  'sp.toList': 'Back to list',
});
